import { $extend } from './functional';

/* 身份ID */
// eslint-disable-next-line no-unused-vars
const identity = [
    {
        'identity_id': 1,
        'identity_name': '优学派管理员',
    },
    {
        'identity_id': 2,
        'identity_name': '工作人员',
    },
    {
        'identity_id': 3,
        'identity_name': '学校管理员',
    },
    {
        'identity_id': 4,
        'identity_name': '教师',
    },
    {
        'identity_id': 5,
        'identity_name': '代理管理员',
    },
    {
        'identity_id': 6,
        'identity_name': '代理职员',
    },
    {
        'identity_id': 7,
        'identity_name': '区域管理员',
    },
    {
        'identity_id': 8,
        'identity_name': '区域职员',
    },
    {
        'identity_id': 9,
        'identity_name': '联盟管理员',
    },
    {
        'identity_id': 10,
        'identity_name': '联盟职员',
    },
    {
        'identity_id': 11,
        'identity_name': '家长',
    },
    {
        'identity_id': 12,
        'identity_name': '学生',
    },
];
/* 机构ID */
// eslint-disable-next-line no-unused-vars
const orgType = [
    {
        org_type: 0,
        org_name: '优学派',
    },
    {
        org_type: 1,
        org_name: '学校',
    },
    {
        org_type: 2,
        org_name: '代理商',
    },
    {
        org_type: 3,
        org_name: '区域',
    },
    {
        org_type: 4,
        org_name: '联盟',
    },
];
/* 模块ID */
// eslint-disable-next-line no-unused-vars
const moduleCode = [
    {
        name: '用户管理',
        code: '001',
    },
    {
        name: '单位管理',
        code: '002',
    },
    {
        name: '日志管理',
        code: '003',
    },
    {
        name: '教材管理',
        code: '004',
    },
    {
        name: '班级管理',
        code: '005',
    },
    {
        name: '习题管理',
        code: '006',
    },
    {
        name: '项目管理',
        code: '007',
    },
    {
        name: '我的资源',
        code: '008',
    },
];
let conditions = [
    {
        name: '销售公司关联',
        prop: 'relate',
        selectedAll: '',
        tabs: [
            {
                label: '已关联',
                value: 1,
            },
            {
                label: '未关联',
                value: 0,
            },
            {
                label: '已禁用',
                value: 2,
            },
        ],
    },
    {
        name: '模板类型',
        prop: 'templateType',
        selectedAll: '',
        tabs: [
            {
                label: 'H5',
                value: 1,
            },
            {
                label: 'web',
                value: 0,
            },
        ],
    },
    {
        name: '模板状态',
        prop: 'templateActive',
        selectedAll: '',
        tabs: [
            {
                label: '启用',
                value: 1,
            },
            {
                label: '禁用',
                value: 0,
            },
        ],
    },
    {
        name: '站点状态',
        prop: 'pageActive',
        selectedAll: '',
        tabs: [
            {
                label: '启用',
                value: 1,
            },
            {
                label: '禁用',
                value: 0,
            },
        ],
    },
    {
        name: '所属单位类型',
        prop: 'companyType',
        selectedAll: '',
        tabs: [
            {
                label: '优学派',
                value: 0,
            },
            {
                label: '学校',
                value: 1,
            },
            {
                label: '代理',
                value: 2,
            },
            {
                label: '区域',
                value: 3,
            },
            {
                label: '联盟',
                value: 4,
            },
        ],
    },
    {
        name: '国家',
        prop: 'country',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '省',
        prop: 'provinces',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '网点所属区域',
        prop: 'newprovinces',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '市',
        prop: 'city',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '区/县',
        prop: 'county',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '学校状态',
        prop: 'schoolStatus',
        selectedAll: '',
        tabs: [
            {
                label: '已启用',
                value: 0,
            },
            {
                label: '已停用',
                value: 1,
            },
        ],
    },
];

/* 教材知识点 */
const textBookLimit = [
    {
        name: '教辅品牌',
        prop: 'assistantBrand',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '版本',
        prop: 'editionId',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '年级',
        prop: 'systemGradeId',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '专题分类',
        prop: 'categoryId',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '学期',
        prop: 'teamId',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '必选修',
        prop: 'volumneId',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '系列标签',
        prop: 'tagId',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '启用状态',
        prop: 'status',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [],
    },
    {
        name: '关联状态',
        prop: 'assistantStatus',
        selectedAll: '',
        tabs: [
        ],
    },
    {
        name: '上下架状态',
        prop: 'onShelvesStatus',
        selectedAll: '',
        tabs: [
        ],
    },
    {
        name: '学制',
        prop: 'eduSystem',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
        ],
    },
    {
        name: '学段',
        prop: 'periodId',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
        ],
        beforeCheck (data, update) {
            if (data.hasOwnProperty('periodId') && data.hasOwnProperty('subjectId')) {
                let send = {};
                Object.entries(data).forEach(([k, v]) => {
                    if (k === 'periodId') {
                        send.periodId = v;
                    } else {
                        send[k] = '';
                    }
                });
                Object.assign(data, send);
                update(send);
            }
            return true;
        },
    },
    {
        name: '学科',
        prop: 'subjectId',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
        ],
    // multiple: true,
    },
    {
        name: '分类',
        prop: 'knowledgeType',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
        ],
    },
    {
        name: '毕业年份',
        prop: 'graduatedYear',
        skyLabel: '全部',
        selectedAll: '',
        tabs: (() => {
            let d = new Date().getFullYear();
            return [
                { label: d + '年', value: d },
                { label: d - 1 + '年', value: d - 1 },
                { label: d - 2 + '年', value: d - 2 },
                { label: '其他', value: 0 },
            ];
        })(),
    },
    {
        name: '学校',
        prop: 'schoolId',
        skyLabel: '全部',
        selectedAll: '',
        class: 'hidden-check',
        tabs: [],
    },
];

/* 项目管理 */
const projLimit = [
    {
        name: '项目类型',
        prop: 'projType',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
            {
                label: '习题项目',
                value: 1,
            },
        ],
    },
    {
        name: '任务类型',
        prop: 'taskType',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
            {
                label: '习题录入',
                value: 1,
            },
            {
                label: '习题审核',
                value: 2,
            },
        ],
    },
    {
        name: '审核次数',
        prop: 'checkTimes',
        skyLabel: '全部',
        selectedAll: '',
        tabs: [
            {
                label: '0次',
                value: 1,
            },
            {
                label: '1次',
                value: 2,
            },
            {
                label: '2次',
                value: 3,
            },
            {
                label: '3次',
                value: 4,
            },
            {
                label: '大于3次',
                value: 5,
            },
        ],
    },
];

/* 账号使用状态 */
export const inLocked = {
    0: '正常',
    1: '锁定',
};

/* 账号是否激活 */
export const isPhonevalidated = {
    0: '否',
    1: '是',
};

/* 账号登录状态 */
export const loggedStatus = {
    0: '没有记录',
    1: '成功',
    2: '异常',
};

/* 页码组件，每一页显示条数 */
export const pageSizes = [10, 20, 50, 100, 200];

/* 筛选查询时的条件归类 */
export function getConditions (p = []) {
    let pool = [...conditions, ...textBookLimit, ...projLimit];
    return p.map(k => {
        return $extend(true, {}, (pool.find(({ prop, tabs }) => prop === k) || {}));
    }).filter(itm => itm.name);
}

// 查找根节点
export function findRootNode (flatTreeList, catalogId, layer = 1) {
    const node = flatTreeList.find(itm => +itm.catalogId === +catalogId);
    if (node) {
        if (node.catalogLevel <= layer) {
            return node;
        }
        return findRootNode(flatTreeList, node.pCatalogId);
    }
    return {
        name: '',
    };
}

export function openUrl (url, target = '_blank') {
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('target', target);
    const id = new Date().getTime() + '';
    a.setAttribute('id', id);
    // 防止反复添加
    if (!document.getElementById(id)) document.body.appendChild(a);
    a.click();
    a.remove();
}

export function loginByUserToken (_callback) {
    let getters = window.yxpapi.store.getters,
        jwtRefresh = getters['global/loginInfo'].jwtRefresh,
        firstLoginTime = getters['global/firstLoginTime'] || new Date().getTime() + '';
    if (jwtRefresh) {
        window.yxpapi.utils.loginByUserToken(jwtRefresh, false, { firstLoginTime }).then(res => {
            if (res.errcode === 0) {
                _callback && _callback(true);
            }
        });
    } else {
        _callback && _callback(false);
    }
}

/**
 * 获取页面文件名
 * @param url 文件url
 */
export function downloadUrlFile (url, name, callback) {
    url = url.replace(/\\/g, '/');
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
    xhr.onload = () => {
        callback && callback(xhr.status);
        if (xhr.status === 200) {
            // 获取文件blob数据并保存
            const fileName = name || getFileName(url);
            saveAs(xhr.response, fileName);
        } else if (xhr.status === 404) {
            window.ELEMENT.Message({
                type: 'error',
                message: '该文件不存在，请联系工作人员',
            });
        } else {
            window.ELEMENT.Message({
                type: 'error',
                message: `下载文件出错，${xhr.status}`,
            });
        }
    };
    xhr.onerror = (e) => {
        // eslint-disable-next-line
        callback && callback('error');
        window.ELEMENT.Message({
            type: 'error',
            message: `下载文件出错`,
        });
    };
    xhr.send();
}

/**
 * URL方式保存文件到本地
 * @param data 文件的blob数据
 * @param name 文件名
 */
function saveAs (data, name) {
    const urlObject = window.URL || window.webkitURL || window;
    const export_blob = new Blob([data]);
    const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    save_link.href = urlObject.createObjectURL(export_blob);
    save_link.download = name;
    save_link.click();
}

/**
 * 根据文件url获取文件名
 * @param url 文件url
 */
function getFileName (url) {
    const num = url.lastIndexOf('/') + 1;
    let fileName = url.substring(num);
    // 把参数和文件名分割开
    fileName = decodeURI(fileName.split('?')[0]);
    return fileName;
}

/* 家长关系 */
export const relationship = [
    {
        value: 'father',
        label: '爸爸',
    },
    {
        label: '妈妈',
        value: 'mother',
    },
    {
        label: '爷爷',
        value: 'paternalGrandpa',
    },
    {
        label: '奶奶',
        value: 'paternalGrandma',
    },
    {
        label: '外公',
        value: 'maternalGrandpa',
    },
    {
        label: '外婆',
        value: 'maternalGrandma',
    },
    {
        label: '其他',
        value: 'other',
    },
];
